import { MutationCache, QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query'
import type { PropsWithChildren } from 'react'

import { ToastViewport } from '@/components/ui/ToastViewport'
import { pushErrorToast } from '@/lib/toast'

function getErrorMessage(error: unknown) {
  return error instanceof Error ? error.message : '请求失败，请稍后重试'
}

const queryClient = new QueryClient({
  mutationCache: new MutationCache({
    onError: error => {
      pushErrorToast(getErrorMessage(error))
    },
  }),
  queryCache: new QueryCache({
    onError: error => {
      pushErrorToast(getErrorMessage(error), '读取失败')
    },
  }),
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
})

export function AppProviders({ children }: PropsWithChildren) {
  return (
    <QueryClientProvider client={queryClient}>
      {children}
      <ToastViewport />
    </QueryClientProvider>
  )
}
